// extracted by mini-css-extract-plugin
export default {"container":"FQjDEG","externalLinksGroup":"ADzmnn","externalLink":"ElUKxe","text":"HHL8Qf"};